import { Injectable } from '@angular/core';
import { Telecom, TelecomAPIResponse } from '../interfaces/telecom';
import { HoursOfOperation, HoursOfOperationAPIResponse } from '../interfaces/datatypes-fhir';


@Injectable({
  providedIn: 'root'
})

export class HoursOperationAdapter {

    
  public adapterToModel(hourOfOperationFHIR: HoursOfOperationAPIResponse[]): HoursOfOperation[] {
   
    const daysOfWeekMap: { [key: string]: number } = {
      "sun": 0,
      "mon": 1,
      "tue": 2,
      "wed": 3,
      "thu": 4,
      "fri": 5,
      "sat": 6
    };


    return hourOfOperationFHIR?.map(item => {

     
      const index =  item.daysOfWeek[0].toLowerCase() as keyof typeof daysOfWeekMap
      const dayOfWeek = daysOfWeekMap[index];

      const timeStart = item.openingTime 
      const timeEnd = item.closingTime
    
      return {
        dayOfWeek,
        timeStart,
        timeEnd
      };

    });


  }
  

  public adaptToAPIFormat(hoursOfOperationModel: HoursOfOperation[]) : HoursOfOperationAPIResponse[] {
   
    const originalHoursOfOperation: HoursOfOperationAPIResponse[] = [];

    hoursOfOperationModel.forEach(hoursOperation => {
      const daysOfWeek: string[] = this.convertDayOfWeekReverse(hoursOperation.dayOfWeek);
      const openingTime: string = hoursOperation.timeStart;
      const closingTime: string = hoursOperation.timeEnd;

      originalHoursOfOperation.push({ daysOfWeek, openingTime, closingTime, allDay: false });
    });



    return originalHoursOfOperation;

  }

  private convertDayOfWeek(dayOfWeek: string): string {
    switch (dayOfWeek) {
      case 'Domingo':
        return 'sun';
      case 'Segunda':
        return 'mon';
      case 'Terça':
        return 'tue';
      case 'Quarta':
        return 'wed';
      case 'Quinta':
        return 'thu';
      case 'Sexta':
        return 'fri';
      case 'Sábado':
        return 'sat';
      default:
        return '';
    }
  }



  private convertDayOfWeekReverse(dayOfWeek: number | string): string[] {
    switch (dayOfWeek) {
      case 0:
        return ['sun'];
      case 1:
        return ['mon'];
      case 2:
        return ['tue'];
      case 3:
        return ['wed'];
      case 4:
        return ['thu'];
      case 5:
        return ['fri'];
      case 6:
        return ['sat'];
      default:
        return [];
    }
  }

  


}